import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const approveTimeOffHr = async (
	port: TimeOffPort,
	id: string,
	actorId: string,
	actorName: string,
	notify: NotifyPort,
): Promise<TimeOffRequest> => {
	try {
		const request = await port.approveHr(id, actorId, actorName)
		notify.success('hr.requestApprovedByHr')
		return request
	} catch {
		notify.error('hr.requestApproveFailed')
		throw new Error('Failed to approve request.')
	}
}

export { approveTimeOffHr }
